// Money is stored as integer minor units (cents). These helpers are the single
// place major<->minor conversion — and its rounding — happens, so the rule is
// defined and tested exactly once instead of copy-pasted into every form.

/** Minor units (cents) → major units as a number. `12345` → `123.45`. */
export function minorToMajor(minor: number): number {
  return minor / 100;
}

/** Minor units → the major-unit string a form input shows. `12345` → `"123.45"`, `0` → `"0"`. */
export function minorToMajorInput(minor: number): string {
  return (minor / 100).toString();
}

/**
 * Major units (a number, or the raw string from a `type="number"` input) →
 * integer minor units, rounded half-up. `"123.45"` → `12345`.
 * Blank or non-numeric input yields `0` (a numeric input can't hold that anyway).
 */
export function majorToMinor(major: number | string): number {
  const n = typeof major === "string" ? Number(major) : major;
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100);
}
